import React from 'react';
import { Reveal } from '../Reveal';
import { SiblingChoiceGrid } from '../SiblingChoiceGrid';
import type { SiblingRole } from '../../types/snak';
interface OpeningScreenProps {
  selected: SiblingRole | null;
  onSelect: (role: SiblingRole) => void;
}
export function OpeningScreen({
  selected,
  onSelect
}: OpeningScreenProps) {
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-359" data-mp="3aezukfh0blvd">
      <Reveal data-id="element-360" data-mp="2mo487xvblivi">
        <p className="font-body text-[13px] leading-relaxed text-[rgba(1,51,43,0.55)]" data-id="element-361" data-mp="2mpxcj6ignr0c">
          Before you meet the Filteks...
        </p>
      </Reveal>
      <Reveal delay={0.08} data-id="element-362" data-mp="2wep43djm09aq">
        <h1 className="mt-1 font-heading text-[42px] leading-[0.95] tracking-[-0.02em] text-background" data-id="element-363" data-mp="2weytaywtycfd">
          What are you?
        </h1>
      </Reveal>
      <Reveal delay={0.16} data-id="element-364" data-mp="2rm5qigkx9e5x">
        <p className="mt-3 font-body text-[13px] text-[rgba(1,51,43,0.5)]" data-id="element-365" data-mp="23xuubqq682nz">
          Pick your place in the family.
        </p>
      </Reveal>

      <div className="mt-6" data-id="element-366" data-mp="1yyrz0xzztat7">
        <SiblingChoiceGrid selected={selected} onSelect={onSelect} data-id="element-367" data-mp="1yxgugvyq3z11" />
      </div>
    </div>;
}